<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">월간인사관리</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]" @click="menuClick(index)">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div
                v-for="(subMenu, idx) in menu.subMenu"
                :key="'subMenu' + idx"
                :class="['sub-menu__item', {on: subMenu.selected}]"
                @click="subMenuClick(index, idx)"
              >
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="right-title">
          <div class="right-title__left">
            <div class="left-top">
              <hr-icon />
              <div class="is-12m">{{ boardData.dataTypeName }}</div>
            </div>
            <div class="title">{{ boardData.title }}</div>
            <div class="left-bot is-12m">{{ boardData.subtitle }}</div>
          </div>
          <div class="right-title__right">
            <div v-if="boardData.previewImgPath" class="is-14m preview-btn" @click="onClickPreview">미리보기</div>
            <div v-if="boardData.price > 0" class="cart-btn" @click="postCart">장바구니 담기</div>
            <div class="is-14m" @click="onClickDown">다운로드</div>
          </div>
        </div>
        <div class="detail-subject">소개</div>
        <img v-if="boardData.thumbnailImgPath" :src="boardData.thumbnailImgPath" class="thumb-img" alt="썸네일 이미지" />
        <div class="introduction is-14r" v-html="boardData.introduction" />
        <div class="detail-subject">금액</div>
        <div class="introduction is-14r">{{ comma(boardData.price) }} 원</div>
        <div class="list">
          <div class="top-navi">
            <div
              v-for="(item, index) in dataTypeList"
              :key="'korNav' + index"
              :class="['nav-item', {on: item.selected}]"
              @click="changeNavItem(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <PropertyRightBtn class="right-btn" />
          <div class="list-container">
            <div class="search-wrap">
              <input
                type="text"
                :value="magazineSearchInfo.keyword"
                @input="inputSearchData($event)"
                placeholder="검색"
                @keyup.enter="getMagazineDataBoardList"
              />
              <search-icon class="search-icon" @click="getMagazineDataBoardList" />
            </div>
            <div class="list-wrap">
              <div class="list-top">
                <div class="top-item type">분류</div>
                <div class="top-item title">제목</div>
                <div class="top-item">분량</div>
                <div class="top-item">미리보기</div>
                <div class="top-item">형식</div>
                <div class="top-item">등급</div>
              </div>
              <div class="list-item__wrap">
                <div
                  v-for="(magazine, idx) in magazineList"
                  :key="'hr' + idx"
                  :class="['list-item', {active: magazine.id === boardData.id}]"
                  @click="goDetail(magazine.id)"
                >
                  <div class="item-type">{{ magazine.dataTypeName }}</div>
                  <div class="item-title">
                    <div class="title">{{ magazine.title }}</div>
                    <div class="sub-title">{{ magazine.subtitle }}</div>
                  </div>
                  <div class="item is-12r">{{ magazine.pageCount }}P</div>
                  <div class="item">
                    <download-icon v-if="magazine.previewImgPath" @click.self.stop="onClickPreviewImg(magazine.previewImgPath)" />
                  </div>
                  <div class="item">
                    <small-pdf-icon />
                  </div>
                  <div :class="['rate', 'item', {paid: magazine.isPaid}]">
                    {{ magazine.isPaid === 1 ? '유료' : '무료' }}
                  </div>
                </div>
              </div>
              <pagination
                :total-count="magazineSearchInfo.totalCount"
                :now-page="magazineSearchInfo.page"
                :limit="magazineSearchInfo.limit"
                @changePage="listChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {useMagazineStore} from '~/store/magazine/index.js'
import {useOrderStore} from '~/store/order/index.js'
import {useMemberStore} from '~/store/member/index.js'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import HrIcon from 'assets/svg/hr-icon.vue'
import PropertyRightBtn from '~/components/common/PropertyRightBtn.vue'
import Pagination from '~/components/common/Pagination.vue'
import SmallPdfIcon from 'assets/svg/small-pdf-icon.vue'
import SearchIcon from 'assets/svg/search-icon.vue'
import DownloadIcon from 'assets/svg/download-icon.vue'

export default {
  name: 'boardId',
  components: {DownloadIcon, SearchIcon, SmallPdfIcon, Pagination, PropertyRightBtn, HrIcon, BreadCrumb},
  setup() {
    const store = useMagazineStore()
    const orderStore = useOrderStore()
    const memberStore = useMemberStore()
    return {store, orderStore, memberStore}
  },
  data() {
    return {
      boardId: null,
      isAuth: false,
      menuList: [
        {
          name: '월간인사관리 안내',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월간인사관리 안내', selected: false}]
        },
        {
          name: '목차',
          selected: true,
          subMenuShow: true,
          subMenu: [
            {name: '전체보기', selected: false},
            {name: 'Feature', selected: false},
            {name: 'Department', selected: false},
            {name: 'P&O', selected: false}
          ]
        },
        {
          name: '월호보기',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월호보기', selected: false}]
        },
        {
          name: '구독 신청',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '구독 신청', selected: false}]
        },
        {
          name: '월간인사관리 광고문의',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '월간인사관리 광고문의', selected: false}]
        }
      ],
      breadCrumb: ['홈', '월간인사관리', '목차', '상세'],
      boardData: {
        id: 0,
        type: '',
        dataType: '',
        dataTypeName: '',
        title: '',
        subtitle: '',
        introduction: '',
        previewImgPath: null,
        thumbnailImgPath: null,
        pageCount: 0,
        isPaid: 0,
        price: 0,
        attachedFiles: [
          {
            name: '',
            date: '',
            url: '',
            expiresDate: 0
          }
        ],
        isSubscribed: false,
        downloadAvailable: false
      },
      dataTypeList: [
        {
          id: '',
          name: '',
          selected: true
        }
      ],
      magazineList: [
        {
          id: 0,
          type: '',
          dataType: '',
          dataTypeName: '',
          title: '',
          subtitle: '',
          introduction: '',
          previewImgPath: null,
          pageCount: 0,
          isPaid: 0,
          price: 0
        }
      ],
      magazineSearchInfo: {
        type: '01',
        keyword: '',
        page: 1,
        limit: 20,
        totalCount: 0,
        dataType: ''
      },
      naviController: 0
    }
  },
  created() {
    this.boardId = this.$route.params.boardId
  },
  async mounted() {
    this.isAuth = this.memberStore.isAuthenticated
    const subMenu = this.$route.query.subMenu
    this.magazineSearchInfo.dataType = this.$route.query.dataType || ''
    this.magazineSearchInfo.page = Number(this.$route.query.page) || 1
    this.magazineSearchInfo.keyword = this.$route.query.keyword || ''
    this.menuList[1].subMenu[subMenu].selected = true
    const typeMap = {
      1: '01',
      2: '02',
      3: '03'
    }
    this.magazineSearchInfo.type = typeMap[subMenu] || '01'
    await this.getMagazineDataBoardDetail()
    await this.getMagazineDataBoardList()
  },
  methods: {
    onClickPreviewImg(url) {
      window.open(url)
    },
    async getMagazineDataBoardList() {
      try {
        const {data} = await this.store.getMagazineDataBoardList(this.magazineSearchInfo)
        this.magazineList = data.list
        this.magazineSearchInfo.totalCount = data.count

        if (this.naviController === 0) {
          this.dataTypeList = data.dataTypeList
          this.naviController = 1
        }

        if (this.$route.query.dataType) {
          this.dataTypeList.forEach(el => {
            if (el.id === this.$route.query.dataType) {
              el.selected = true
            } else {
              el.selected = false
            }
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    changeNavItem(item) {
      this.dataTypeList.forEach(el => {
        el.selected = false
      })
      item.selected = true
      this.magazineSearchInfo.dataType = item.id
      this.magazineSearchInfo.page = 1

      this.getMagazineDataBoardList()
    },
    inputSearchData(e) {
      this.magazineSearchInfo.keyword = e.target.value
    },
    goDetail(id) {
      this.$router.push(`/magazine/board/${id}?subMenu=${this.$route.query.subMenu}`)
    },
    listChangePage(page) {
      this.magazineSearchInfo.page = page
      this.getMagazineDataBoardList()
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    onClickPreview() {
      if (this.boardData.previewImgPath) {
        window.open(this.boardData.previewImgPath, '_blank')
      }
    },
    async onClickDown() {
      if (!this.isAuth) {
        alert('로그인 후 이용 가능합니다.')
        return
      }
      // 다운로드 가능 체크
      const {data} = await this.store.getMagazineDataBoardDownload(this.boardId)
      this.boardData.downloadAvailable = data.downloadAvailable
      this.boardData.attachedFiles = data.attachedFiles

      if (this.boardData.downloadAvailable) {
        this.boardData.attachedFiles.forEach(file => {
          window.open(file.url, '_blank')
        })
      } else {
        alert('결제 후 이용 가능합니다.')
        this.$router.push(`/magazine/board/payment?boardId=${this.boardId}`)
      }
    },
    menuClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/magazine?menu=0&subMenu=0')
          break
        case 1:
          this.$router.push('/magazine?menu=1&subMenu=0')
          break
        case 2:
          this.$router.push('/magazine?menu=2&subMenu=0')
          break
        case 3:
          this.$router.push('/magazine?menu=3&subMenu=0')
          break
        case 4:
          this.$router.push('/magazine?menu=4&subMenu=0')
          break
      }
      window.scrollTo({top: 0})
    },
    subMenuClick(index, idx) {
      this.$router.push(`/magazine?menu=${index}&subMenu=${idx}`)
      window.scrollTo({top: 0})
    },
    async getMagazineDataBoardDetail() {
      try {
        const {data} = await this.store.getMagazineDataBoardDetail(this.boardId)
        this.boardData = data
        // 빈 객체일 경우 alert 후 홈 화면으로 이동
        if (Object.keys(this.boardData).length === 0) {
          alert('존재하지 않는 게시물입니다.')
          this.$router.push('/')
        }
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    async postCart() {
      try {
        if (!this.isAuth) {
          alert('로그인 후 이용 가능합니다.')
          return
        }
        await this.orderStore.postCart({targetId: this.boardId, type: '03'})
        if (confirm('장바구니에 담겼습니다.장바구니로 이동하시겠습니까?')) {
          this.$router.push('/cart')
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail-subject {
  padding: 12px 0px;
  border-bottom: 2px solid #0058aa;
  color: #0058aa;
  font-family: 'Godo', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
}

.thumb-img {
  width: fit-content;
  margin-bottom: 24px;
}

.default-container {
  padding: 48px 0 100px;

  .content {
    display: flex;
    gap: 24px;
    position: relative;
    margin-bottom: 24px;

    .content-left {
      min-width: 222px;
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;

      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }

      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;

        &:hover {
          color: #0058aa;
        }

        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }

      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }

        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }

        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }

    .content-right {
      width: 100%;

      .right-title {
        border-top: 1px solid #dbdbdb;
        border-bottom: 1px solid #dbdbdb;
        background: #f8fbfd;
        padding: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        .right-title__left {
          .left-top {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 8px;
          }

          .title {
            color: #0058aa;
            font-family: 'Godo', sans-serif;
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 4px;
            max-width: 390px;
          }

          .left-bot {
            color: #606060;
          }
        }

        .right-title__right {
          display: flex;
          gap: 8px;

          .preview-btn {
            padding: 7px 12px;
            border-radius: 4px;
            border: 1px solid #dbdbdb;
            background: #fff;
            cursor: pointer;
            color: #0058aa;
          }
        }

        .is-14m {
          display: flex;
          padding: 7px 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          color: #fff;
          border-radius: 4px;
          border: 1px solid #dbdbdb;
          background: #0058aa;
          cursor: pointer;
        }
      }

      .introduction {
        white-space: pre-line;
        padding: 0 24px;
        margin-bottom: 24px;
      }
    }

    .top-navi {
      display: flex;
      border-bottom: 1px solid #dbdbdb;
      flex-wrap: wrap;
      margin-bottom: 24px;

      .nav-item {
        padding: 18px 16px;

        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #606060;
        position: relative;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        cursor: pointer;

        &:hover {
          color: #0058aa;
        }

        &.on {
          color: #0058aa;

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            display: block;
            width: 100%;
            height: 3px;
            background: #0058aa;
          }
        }
      }
    }

    .list {
      .right-btn {
        margin-bottom: 24px;
      }

      .list-container {
        .right-btn {
          margin-bottom: 24px;
        }

        .search-wrap {
          padding: 9px;
          border-radius: 4px;
          border: 1px solid #dbdbdb;
          background: #fff;
          display: flex;
          justify-content: space-between;
          margin-bottom: 16px;

          input {
            border: none;
            width: 100%;
            outline: none;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 125%; /* 17.5px */
            &::placeholder {
              color: #bdbdbd;
            }
          }

          .search-icon {
            cursor: pointer;
          }
        }

        .list-wrap {
          .list-top {
            display: flex;
            border-bottom: 1px solid #909090;
            background: #fbfbfb;

            .top-item {
              padding: 12px 16px;
              width: 56px;
              color: #606060;
              font-size: 12px;
              font-style: normal;
              font-weight: 500;
              line-height: 125%; /* 15px */
              letter-spacing: -1px;

              &.type {
                width: 108px;
              }

              &.title {
                width: 54%;
              }
            }
          }

          .list-item__wrap {
            margin-bottom: 24px;

            .list-item {
              display: flex;
              border-bottom: 1px solid #dbdbdb;
              cursor: pointer;

              &.active {
                background: #f8fbfd;
              }

              .item-type {
                width: 108px;
                color: #121212;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 125%; /* 15px */
                letter-spacing: -0.2px;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .item-title {
                width: 54%;
                padding: 16px;

                .title {
                  color: #121212;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: 125%; /* 17.5px */
                  letter-spacing: -0.2px;
                  margin-bottom: 4px;
                }

                .sub-title {
                  color: #212121;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 125%; /* 15px */
                  letter-spacing: -0.2px;
                }
              }

              .item {
                padding: 16px;
                width: 56px;
                display: flex;
                align-items: center;
                justify-content: center;

                &.rate {
                  color: #0058aa;
                  background: rgba(0, 88, 170, 0.05);
                  text-align: center;
                  font-family: Pretendard;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 125%; /* 17.5px */
                  letter-spacing: -0.2px;
                }

                &.paid {
                  color: #e40e0e;
                  background: rgba(228, 14, 14, 0.05);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
